import {dateTime} from "services/date";
import {Collection} from "types/Collection";

/**
 * Transform the given collection by deserializing object properties
 *
 * @internal
 * @param collection
 */
export default function deserializeCollection(collection: any): Collection {
    collection.created_at = dateTime(collection.created_at)
    collection.updated_at = dateTime(collection.updated_at)

    return collection;
}